import LookupStatesRequestModelBase from '../_generated/modelBases/lookup-states-request-model-base';

export default class LookupStatesRequestModel extends LookupStatesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
